import { createRouter, createWebHistory } from "vue-router"

import routes from "@router/paths"
import { clearChunkReloadFlag, hasChunkReloadFlag } from "@utils/lazy-import"
import { useErrorStore } from "@stores/models/error.store"

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

// Every wording a browser uses when a hashed chunk from a previous build is
// gone. The CSS one matters as much as the import ones: Vite checks a lazy
// route's CSS dependencies BEFORE importing the module, so a stale build most
// often surfaces as "Unable to preload CSS" and would otherwise fall straight
// through this handler, leaving a blank view with no retry offered.
const STALE_ASSET_MESSAGES = [
  "failed to fetch dynamically imported module",
  "error loading dynamically imported module",
  "importing a module script failed",
  "unable to preload css",
  "expected a javascript module script"
]

function isStaleAssetError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error ?? "")
  const normalized = message.toLowerCase()

  return STALE_ASSET_MESSAGES.some(candidate => normalized.includes(candidate))
}

router.onError((error, to) => {
  if (isStaleAssetError(error)) {
    if (hasChunkReloadFlag()) {
      const errorStore = useErrorStore()
      errorStore.showIntegrityError(() => {
        clearChunkReloadFlag()
        window.location.assign(to.fullPath)
      })
      return
    }
    window.location.assign(to.fullPath)
  }
})

router.afterEach(() => {
  clearChunkReloadFlag()
})

// router.beforeEach(async (to, _from, next) => {
//   console.log(to);
//   next();
// });
